import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';

export const Tooltip = styled.div`
  display: none;

  font-size: 12px;

  position: absolute;

  top: ${(props) => props.top || '100%'};

  box-shadow:
    rgb(0 0 0 / 20%) 0px 5px 5px -3px,
    rgb(0 0 0 / 14%) 0px 8px 10px 1px,
    rgb(0 0 0 / 12%) 0px 3px 14px 2px;

  color: ${(props) => props.color || '#fff'};

  background: ${(props) => props.backgroundColor || 'rgba(0, 0, 0, 0.7)'};

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;

  border-radius: 4px;

  line-height: ${(props) => props.lineHeight || '1.5'};

  padding: ${(props) => props.padding || '8px 16px'};

  margin: ${(props) => props.margin || null};

  width: ${(props) => (props.isSafari ? '-webkit-max-content' : 'max-content')};
  z-index: 2;

  ${(props) => {
    const { popOver, showToolTip } = props;
    if (popOver) {
      return css`
        display: ${showToolTip ? 'block' : 'none'};
      `;
    }
    return null;
  }}

  ${(props) => {
    const { renderTooltip } = props;

    switch (renderTooltip) {
      case 'end':
        return css`
          right: 0px;
        `;
      default:
        return css`
          left: 0;
        `;
    }
  }}

${(props) => {
    const { index, leftPaneTooltip } = props;
    if (leftPaneTooltip) {
      return css`
        top: ${32 * (index + 1) + 12}px;
        left: 40px;
        z-index: 3;

        @media ${breakpointsMinWidth.desktopMd} {
          top: ${40 * (index + 1) + 16}px;
        }
      `;
    }
    return null;
  }}
`;

export default Tooltip;
